"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TableStatusDisplayPageActions;
(function (TableStatusDisplayPageActions) {
    TableStatusDisplayPageActions["Loading"] = "Loading";
    TableStatusDisplayPageActions["Loaded"] = "Loaded";
})(TableStatusDisplayPageActions || (TableStatusDisplayPageActions = {}));
exports.default = TableStatusDisplayPageActions;
